(() => {
  const polish = () => {
    if (location.pathname === '/pages/our-mission') {
      document.body.classList.add('template-glowpup-mission');
    }

    const faq = document.querySelector('.glowpup-proof__faq');
    if (faq && !faq.id) faq.id = 'glowpup-faqs';

    document.querySelectorAll('.glowpup-cart-upsell small').forEach((label) => {
      if (label.textContent.trim() === 'Complete the walk') {
        label.textContent = 'Complete the Night-Walk Set';
      }
    });

    document.querySelectorAll('.glowpup-cart-upsell__button').forEach((button) => {
      if (button.textContent.trim() === 'Choose') button.textContent = 'View options';
    });

    if (location.hash === '#glowpup-faqs' && faq) {
      setTimeout(() => faq.scrollIntoView({ behavior: 'smooth', block: 'start' }), 80);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', polish, { once: true });
  } else {
    polish();
  }
  document.addEventListener('shopify:section:load', polish);
})();